// extracted by mini-css-extract-plugin
module.exports = {"page":"Screen_page__1OBpj","card":"Screen_card__6Mfmv","indicator":"Screen_indicator__3Tvw6","buttons":"Screen_buttons__31Q3F"};